<script setup lang="ts">
import { useBox } from '~/composables/api/useBox'

const statisticsResponse = await useAsyncData(() =>
  useBox('references_header_stats')
)
</script>

<template>
  <div class="c-references-header-stats">
    <div class="c-references-header-stats__items">
      <div
        v-for="statistic in statisticsResponse.data.value?.box_items"
        :key="statistic.name"
        class="c-references-header-stats__item"
      >
        <span v-html="statistic.name" />
        <strong v-html="statistic.module_data.value" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-references-header-stats {
  display: flex;
  justify-content: flex-end;

  @include breakpoint-down('lg') {
    justify-content: stretch;
  }

  &__items {
    display: grid;
    grid-template-columns: repeat(2, auto);
    gap: 40px 58px;
    color: var(--color-light);

    @include breakpoint-down('lg') {
      grid-template-columns: repeat(4, auto);
      gap: 30px 46px;
      width: 100%;
    }

    @include breakpoint-down('md') {
      grid-template-columns: repeat(2, auto);
      gap: 20px 32px;
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px;

    @include breakpoint-down('md') {
      gap: 6px;
    }

    @include breakpoint-down('xs') {
      gap: 2px;
    }

    strong {
      font-family: var(--font-family-secondary-base);
      font-weight: 400;
      font-size: 58px;
      line-height: 1;
      color: var(--color-secondary);
      margin-bottom: 4px;
      white-space: nowrap;

      @include breakpoint-down('lg') {
        font-size: 48px;
      }

      @include breakpoint-down('md') {
        font-size: 40px;
      }

      @include breakpoint-down('xs') {
        font-size: 32px;
      }
    }

    span {
      font-size: 20px;
      font-weight: 500;
      line-height: 1.2;

      @include breakpoint-down('lg') {
        font-size: 18px;
      }

      @include breakpoint-down('xs') {
        font-size: 16px;
      }
    }
  }
}
</style>
